//Other
export const flowAppGrey = '#353637'; //Only used in old Video code not part of theme.
export const flowAppGrey25 = '#bcc0c2';
export const flowAppBackground50 = 'rgba(238,240,240,0.5)';
export const flowAppSelected = '#F3F3F3';

// Units - https://projects.invisionapp.com/boards/3D2Z7TLT8UZGF
export const tiny = 9; // color code in spec: green
export const small = 12; // color code in spec: yellow
export const medium = 18; // color code in spec: pink
export const lagom = 24; // color code in spec: turquoise
export const large = 36; // color code in spec: orange
export const huge = 48; // color code in spec: purple

//General list heights
export const LIST_ITEM_HEIGHT = 56;
export const LIST_HEADER_ITEM_HEIGHT = 24;

// Chat list item heights
export const chatListItemHeight = 60;
export const chatListHeaderItemHeight = 36;
export const chatListHeaderItemHeight_TW = 28;

// Ticket list item height
export const TICKET_LIST_ITEM_HEIGHT = 103;

// Extension list item heights
export const extensionListItemHeight = 48;

export const extensionListHeaderItemHeight = 24;
export const extensionListLastSectionItemHeight = extensionListItemHeight + 12; // 12 pixels padding

// PBX list item heights
export const pbxListItemHeight = 48;
export const pbxListLastSectionItemHeight = pbxListItemHeight + 12;
export const pbxListHeaderItemHeight = 24;

//Call list item height
export const dateDividerHeight = 24;
export const callItemHeight = 48;
export const recordingItemHeight = 132;

export const callItemDetailCallAnsweredHeight = 80;
export const callItemDetailCallNotAnsweredHeight = 52;
export const callItemDetailCallIncomingMissed = 96;
export const callItemDetailTechnicalNumber = 60;
export const callItemDetailTechnicalNumberMissed = 70;

export const flowButtonHeight = 36;

//Main wrapper heights
export const mainWrapperPaddingTop = 66;

//Nav title heights
export const navTitleHeight = 54;

//Pbx overview heights
export const pbxOverviewQueueItemHeight = 72;
export const pbxOverviewAgentItemHeight = 50;
